/* 22 Oct 2026, Pure Vitamins UK: the bar now stays on screen.
   The original theme script slid the bar out on every upward scroll and
   back in on every downward scroll, with no threshold. On phones, momentum
   scrolling, the address bar resizing and the rubber-band bounce produce
   tiny direction reversals, so the bar slid in and out repeatedly and
   looked shaky. A bottom nav that is always available is also better for
   shoppers, so the hide behaviour is removed. The up/down classes are kept
   so any CSS that reads them still sees the bar as shown. */
if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',

    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        document.body.classList.add('mobile-sticky-bar-enabled');
        this.classList.add('up');
        this.classList.remove('down');
        document.body.classList.remove('mobile-sticky-bar-down');
        document.body.classList.add('mobile-sticky-bar-up');
        this.calculateHeight();
        this.resizeHandler = this.calculateHeight.bind(this);
        window.addEventListener('resize', this.resizeHandler, { passive: true });
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.resizeHandler);
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }
    }
  );
}
